// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wxexplan .van-tab {\n  font-size: 45px;\n  color: #333;\n  line-height: 88px;\n}\n.wxexplan .van-tabs--line .van-tabs__wrap {\n  height: 88px;\n}\n.wxexplan .van-tabs__line {\n  width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
